import React from "react";

function Home() {
  return (
    <React.Fragment>
      <div class="hero" id="home">
        <div class="hero__container">
          <h1 class="hero__heading">
            <span>Build</span> your UI/UX
          </h1>
          <p class="hero__description">
            Unlimited Possibilities by <span>codeApe</span>
          </p>
          <button class="main__btn">
            <a href="https://github.com/Oluwatimi11">Explore GitHub</a>
          </button>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Home;
